export const sliderItems = [
  {
    id: 1,
    img: "https://i.ytimg.com/vi/lxNqBexCMfE/maxresdefault.jpg",
    title: "NEW SHOE DROPS",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4",
  },
    {
      id: 2,
      img: "https://i.ytimg.com/vi/keeYQ6Jvf4o/maxresdefault.jpg",
      title: "SUMMER SALE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "f5fafd",
    },
    {
      id: 3,
      img: "https://www.jaywatson.com/blog/wp-content/uploads/2012/04/Watson_101028_3635_Christian_Hosoi.jpg",
      title: "AUTUMN COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "D3C1B4",
    },
   
  ];

  export const categories = [
    {
      id: 1,
      img: "https://www.jaywatson.com/blog/wp-content/uploads/2011/10/Watson_110917_0045_w.jpg",
      title: "SHIRT STYLE!",
      cat:"shirts"
    },
    {
      id: 2,
      img: "https://www.jaywatson.com/blog/wp-content/uploads/2011/10/Watson_110917_0204_w.jpg",
      title: "Headwear",
      cat:"headwear"
    },
    {
      id: 3,
      img: "https://www.jaywatson.com/blog/wp-content/uploads/2011/10/Watson_110916_0320_M_w.jpg",
      title: "LIGHT JACKETS",
      cat:"jeans"
    },
  ];

  export const popularProducts = [
    {
      id:1,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    {
      id:2,
      img:"https://cdn.shopify.com/s/files/1/0101/4832/products/Angela_Natural_Tee.png?v=1606780388",
    },
    {
      id:3,
      img:"https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
    },
    {
      id:4,
      img:"https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
    },
    {
      id:5,
      img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
    },
    {
      id:6,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
    },
    {
      id:7,
      img:"https://www.vintageindustries.nl/download_front/qympzk1762/2217_Arrow_Jacket_Forest.png",
    },
    {
      id:8,
      img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
  ]